module.exports = __webpack_public_path__ + "static/Donate_to_stop_the_spread-6752c75e50599cdebb19961415394947.jpg";